<template>
  <div class="content">
    <el-dialog title="信息详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               width="880px"
               class="dialog"
               append-to-body>
      <div class="title">
        {{ `${detail.academy_name}-${detail.major_name}详情` }}
      </div>
      <div class="analyse">
        <el-descriptions title="报考信息"
                         :column="1"
                         border>
          <el-descriptions-item v-for="(item, index) in registrationInformationList"
                                :key="index"
                                :label="item.label"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{ item.value }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="分数线"
                         :column="1"
                         border
                         v-if="false">
          <el-descriptions-item label="学院"
                                labelClassName="my-label"
                                content-class-name="my-content">
            <el-dropdown @command="academyHandleCommand">
              <span class="el-dropdown-link">
                {{ academyName }}<i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item"
                                  v-for="(item, index) in fractionalLineList"
                                  :key="index">{{ item.academy_name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-descriptions-item>

          <el-descriptions-item label="方向"
                                labelClassName="my-label"
                                content-class-name="my-content">
            <el-dropdown @command="directionHandleCommand">
              <span class="el-dropdown-link">
                {{ directionName }}<i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item"
                                  v-for="(item, index) in directionList"
                                  :key="index">{{ item.direction_name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- direction -->
          </el-descriptions-item>
          <el-descriptions-item label="2022年分数"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{ getYearScore(2022) }}
          </el-descriptions-item>
          <el-descriptions-item label="2023年分数"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{ getYearScore(2023) }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="调剂分析"
                         :column="1"
                         border>
          <el-descriptions-item label="调剂录取人数"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            {{
              targetItem.college_major_user_count_adjust === null
                ? "-"
                : targetItem.college_major_user_count_adjust +
                  "人"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="调剂最高分"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            {{
              targetItem.college_major_adjust_high_score === null
                ? "-"
                : targetItem.college_major_adjust_high_score +
                  "分"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="录取中位分"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            {{
              targetItem.college_major_adjust_middle_score ===
              null
                ? "-"
                : targetItem.college_major_adjust_middle_score +
                  "分"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="录取最低分"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            {{
              targetItem.college_major_adjust_low_score === null
                ? "-"
                : targetItem.college_major_adjust_low_score + "分"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="调剂来源"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            <div style="width: 90%">
              {{
               targetItem.college_major_adjust_source === null
                  ? "-"
                  : targetItem.college_major_adjust_source
              }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="调剂去向"
                                labelClassName="my-label"
                                content-class-name="my-content"
                                v-if="targetItem">
            <div style="width: 90%">
              {{
                targetItem.college_major_adjust_target === null
                  ? "-"
                  : targetItem.college_major_adjust_target
              }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="一志愿报考985比例"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{
              admissionAnalysis["985"]
                ? (admissionAnalysis["985"] * 100).toFixed(2) + "%"
                : admissionAnalysis["985"] == 0
                ? "0%"
                : "-"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="一志愿报考211比例"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{
              admissionAnalysis["211"]
                ? (admissionAnalysis["211"] * 100).toFixed(2) + "%"
                : admissionAnalysis["211"] == 0
                ? "0%"
                : "-"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="一志愿报考双非比例"
                                labelClassName="my-label"
                                content-class-name="my-content">
            {{
              admissionAnalysis["empty"]
                ? (admissionAnalysis["empty"] * 100).toFixed(2) + "%"
                : admissionAnalysis["empty"] == 0
                ? "0%"
                : "-"
            }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions title="调剂名单"
                         :column="1"
                         border></el-descriptions>
        <el-table class="table"
                  :data="searchRecruitPrepareList"
                  border
                  style="width: 100%">
          <el-table-column label="姓名"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.exam_student_name
                  ? scope.row.exam_student_name == "null"
                    ? "-"
                    : scope.row.exam_student_name
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="录取院校"
                           min-width="140"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.recruit_college_name
                  ? scope.row.recruit_college_name == "null"
                    ? "-"
                    : scope.row.recruit_college_name
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="专业名称"
                           min-width="140"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.recruit_major_name
                  ? scope.row.recruit_major_name == "null"
                    ? "-"
                    : `(${scope.row.recruit_major_code})${scope.row.recruit_major_name}`
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="初试总分"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.first_exam_score
                  ? scope.row.first_exam_score == "null"
                    ? "-"
                    : scope.row.first_exam_score + "分"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="复试总分"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.second_exam_score
                  ? scope.row.second_exam_score == "null"
                    ? "-"
                    : scope.row.second_exam_score + "分"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="总成绩"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.total_exam_score
                  ? scope.row.total_exam_score == "null"
                    ? "-"
                    : scope.row.total_exam_score + "分"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="调剂来源院校"
                           min-width="140"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.first_college_name
                  ? scope.row.first_college_name == "null"
                    ? "-"
                    : scope.row.first_college_name
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="学习方式"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row.recruit_college_enrol_type == 1
                  ? "全日制"
                  : scope.row.recruit_college_enrol_type == 2
                  ? "非全日制"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchAnalyseInfo, searchRecruitPrepare } from '@/api/common.js'
export default {
  data() {
    return {
      academyName: '',
      directionName: '',
      dialogVisible: false,
      dataForm: {},
      detail: {},
      registrationInformationList: [],
      searchRecruitPrepareList: [],
      fractionalLineList: [],
      directionList: [],
      yearList: [],
      admissionAnalysis: {},
      uid: '',
      targetItem: {},
    }
  },
  methods: {
    getYearScore(year) {
      if (this.yearList.length) {
        let yearData = this.yearList.find((item) => item.year == year)
        if (yearData) {
          return `总分${yearData.score_total}分 | 政治${yearData.score_politics}分 | 外语${yearData.score_language}分 | 业务课一${yearData.score_business_1}分 | 业务课二${yearData.score_business_2}分`
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    open(row, uid) {
      this.dialogVisible = true
      this.dataForm = row
      this.uid = uid
      this.getDetail()
    },

    academyHandleCommand(command) {
      this.academyName = command.academy_name
      this.directionList = command.children
      this.directionName = command.children[0].direction_name
      this.yearList = command.children[0].children
    },
    directionHandleCommand(command) {
      this.directionName = command.direction_name
      this.yearList = command.children
    },

    getDetail() {
      searchAnalyseInfo({
        college_sign_str: this.dataForm.college_sign_str,
        uid: this.uid,
      }).then((res) => {
        this.detail = res
        this.getSearchRecruitPrepare()
        if (this.detail?.arr_recruit_analyse) {
          const targetItem = this.detail.arr_recruit_analyse.find(
            (item) => item.year == '2025'
          )
          this.targetItem = targetItem
          if (targetItem?.college_major_adjust_first_percents) {
            try {
              const obj = {}
              targetItem.college_major_adjust_first_percents
                .split(',')
                .forEach((item) => {
                  let list = item.split('_')
                  obj[list[0]] = list[1]
                })
              this.admissionAnalysis = obj
            } catch (error) {
              this.admissionAnalysis = {}
            }
          } else {
            this.admissionAnalysis = {}
          }
        }
        let informationList = [
          {
            label: '政治',
            value: '',
          },
          {
            label: '外语',
            value: '',
          },
          {
            label: '业务课一',
            value: '',
          },
          {
            label: '业务课二',
            value: '',
          },
          {
            label: '参考书目',
            value: '',
          },
          {
            label: '一志愿录取人数',
            value: '',
          },
          {
            label: '一志愿最高分',
            value: '',
          },
          {
            label: '一志愿最低分',
            value: '',
          },
          {
            label: '联系方式',
            value: '',
          },
        ]

        // 获取第一层数组（因为后端返回的是二维数组）
        const subjectArray = this.detail.arr_all_subject_info?.[0] || []

        // 只给前4个科目赋值（政治、外语、业务课一、业务课二）
        for (let i = 0; i < 4; i++) {
          if (informationList[i] && subjectArray[i]) {
            informationList[i].value = subjectArray[i].name || '-'
          }
        }
        informationList[4].value = this.detail.reference_books || '-'
        if (this.targetItem.college_major_user_count_first === null) {
          informationList[5].value = '-'
        } else {
          informationList[5].value =
            this.targetItem.college_major_user_count_first + '人'
        }
        if (this.targetItem.college_major_high_score === null) {
          informationList[6].value = '-'
        } else {
          informationList[6].value =
            this.targetItem.college_major_high_score + '人'
        }
        if (this.targetItem.college_major_low_score === null) {
          informationList[7].value = '-'
        } else {
          informationList[7].value =
            this.targetItem.college_major_low_score + '人'
        }
        informationList[8].value = this.detail.college_contact_phone
        this.registrationInformationList = informationList

        // this.registrationInformationList

        // 分数线
        let fractionalLine = []
        if (!res.arr_college_score_line || !res.arr_college_score_line.length)
          return

        res.arr_college_score_line.forEach((item, index) => {
          if (fractionalLine.length <= 0) {
            fractionalLine.push({
              academy_name: item.academy_name,
              academy_code: item.academy_code,
              children: [],
            })
          } else {
            let obj = fractionalLine.find(
              (its) => its.academy_code == item.academy_code
            )
            if (!obj) {
              fractionalLine.push({
                academy_name: item.academy_name,
                academy_code: item.academy_code,
                children: [],
              })
            }
          }
        })

        fractionalLine.forEach((item) => {
          let dataList = []
          res.arr_college_score_line.forEach((its) => {
            if (item.academy_code == its.academy_code) {
              if (dataList.length <= 0) {
                dataList.push({
                  academy_code: item.academy_code,
                  direction_name: its.direction_name,
                  children: [],
                })
              } else {
                let obj = dataList.find(
                  (dataListIts) =>
                    dataListIts.direction_name == its.direction_name
                )
                if (!obj) {
                  dataList.push({
                    academy_code: item.academy_code,
                    direction_name: its.direction_name,
                    children: [],
                  })
                }
              }
            }
          })

          dataList.forEach((dataListIts) => {
            res.arr_college_score_line.forEach((its) => {
              if (
                dataListIts.academy_code == its.academy_code &&
                dataListIts.direction_name == its.direction_name
              ) {
                dataListIts.children.push(its)
              }
            })
          })

          item.children = dataList
        })
        this.fractionalLineList = fractionalLine
        this.academyName = this.fractionalLineList[0].academy_name
        this.directionList = this.fractionalLineList[0].children
        this.directionName =
          this.fractionalLineList[0].children[0].direction_name
        this.yearList = this.fractionalLineList[0].children[0].children
      })
    },

    getSearchRecruitPrepare() {
      searchRecruitPrepare({
        force_year: 2025,
        pageIndex: 1,
        pageSize: 9999,
        college_sign_str: this.dataForm.college_sign_str,
        uid: this.uid,
      }).then((res) => {
        this.searchRecruitPrepareList = res.list
      })
    },
  },
}
</script>


<style lang="less" scoped>
/deep/ .el-descriptions__header {
  margin-bottom: 12px !important;
  margin-top: 24px;
}

/deep/ .el-descriptions-item__label.is-bordered-label {
  width: 124px !important;
  padding: 0 25px 0 23px;
  background: #f5f7fa !important;
}

.el-dropdown-link {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #303133;
}
.my-label {
  width: 124px;
  background: #dcdfe6 !important;
}
.title {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #303133;
  text-align: center;
}

.tit {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-top: 24px;
}
</style>
